// extracted by mini-css-extract-plugin
export default {"iframeWrapper":"WebViewPage_iframeWrapper__7eju5","iframeDesktop":"WebViewPage_iframeDesktop__yJse5"};